// Node Modules
import axios from 'axios';

/**
 * カテゴリ一覧を取得
 * @param {String} rootPath ルートパス
 * @param {String} taxonomy タクソノミー名
 */
const getNewsCategories = async (rootPath, taxonomy) => {
    return new Promise((resolve, reject) => {
        const url = `${rootPath}/wp-json/wp/v2/${taxonomy}`;
        const config = {
            params: {
                _fields: 'id,name,slug', //取得するフィールド
            }
        };
    
        axios.get(url, config).then(res => {
            // console.log(res.data);
            resolve(res.data);
        
        }).catch(error => {
            console.log(error);
            reject();
        });
    });
}

export default getNewsCategories
